const t = {
  name: "SortAscending",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.4141 9.00015L16.9999 3.58594L11.5857 9.00015L12.9999 10.4144L16 7.41427V19.0001H18V7.41446L20.9999 10.4144L22.4141 9.00015Z" fill="currentColor"/>
<path d="M2 5.00012H10V7.00012H2V5.00012Z" fill="currentColor"/>
<path d="M2 17.0001H13V19.0001H2V17.0001Z" fill="currentColor"/>
<path d="M10 11.0001V13.0001H2V11.0001H10Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SortAscending
};
